import { render, staticRenderFns } from "./InvoiceDesc.vue?vue&type=template&id=a969ab08&scoped=true&"
var script = {}
import style0 from "./InvoiceDesc.vue?vue&type=style&index=0&id=a969ab08&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a969ab08",
  null
  
)

export default component.exports